"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountInfoMapper = void 0;
var AccountInfoMapper = /** @class */ (function () {
    function AccountInfoMapper(data) {
        this.localData = data;
    }
    AccountInfoMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return AccountInfoMapper;
}());
exports.AccountInfoMapper = AccountInfoMapper;
//# sourceMappingURL=AccountInfoMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/AccountInfoMapper.js
// module id = 2056
// module chunks = 8